export enum TabsIndex {
  FormRenderer = 0,
  Analyse = 1,
  Json = 2,
  Output = 3,
}
